import { Component, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { ConfigConstants } from '../../config/config-constants';
import { RouterHelperService } from '../../services/router-helper/router-helper.service';

@Component({
    selector: 'pace-core-navigation-link',
    templateUrl: './navigation-link.component.html',
    styleUrls: ['./navigation-link.component.scss'],
    standalone: false,
})
export class NavigationLinkComponent {
    private navigationLinkNameDictionary: { [key: string]: string } = {};
    public navigationLinkName = '';
    private currentUrl = '';

    public faChevronLeft = faChevronLeft;
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly translate: TranslateService,
        private readonly router: Router,
        private readonly routerHelper: RouterHelperService,
    ) {
        // load names of navigation targets
        this.navigationLinkNameDictionary['/' + ConfigConstants.routeUrlDashboard] = '';
        this.navigationLinkNameDictionary['/' + ConfigConstants.routeUrlConfirmation] = <string>(
            this.translate.instant('APP_HEADER_NOTIFICATION_TITLE')
        );
        this.navigationLinkNameDictionary['/' + ConfigConstants.routeUrlForms] = <string>(
            this.translate.instant('APP_HEADER_NOTIFICATION_TITLE')
        );
        this.navigationLinkNameDictionary['/' + ConfigConstants.routeUrlDetails] = <string>(
            this.translate.instant('APP_HEADER_DASHBOARD_TITLE')
        );
        this.navigationLinkNameDictionary['/' + ConfigConstants.routeUrlTimesheet] = <string>(
            this.translate.instant('APP_HEADER_DASHBOARD_TITLE')
        );
        this.navigationLinkNameDictionary['/' + ConfigConstants.routeUrlWidgets] = <string>(
            this.translate.instant('APP_HEADER_DASHBOARD_TITLE')
        );
        this.navigationLinkNameDictionary['/' + ConfigConstants.routeUrlDocBox] = <string>(
            this.translate.instant('APP_HEADER_NOTIFICATION_TITLE')
        );
        this.navigationLinkNameDictionary['/' + ConfigConstants.routeUrlSmartlocker] = <string>(
            this.translate.instant('APP_HEADER_DASHBOARD_TITLE')
        );

        // initialize link name based on the current URL
        this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            for (const key of Object.keys(this.navigationLinkNameDictionary)) {
                if (event.urlAfterRedirects.indexOf(key) > -1) {
                    this.navigationLinkName = this.navigationLinkNameDictionary[key];
                    break;
                }
            }

            this.currentUrl = event.urlAfterRedirects;
        });
    }

    public navigate(): void {
        let navigationCommands: string[];

        const frontId = this.routerHelper.params.frontid;
        const qmnum = this.routerHelper.params.qmnum;
        const manum = this.routerHelper.params.manum;

        // fill navigationCommands based on the current route
        if (this.currentUrl.indexOf(ConfigConstants.routeUrlDetails) > -1) {
            navigationCommands = [ConfigConstants.routeUrlDashboard];
        } else if (this.currentUrl.indexOf(ConfigConstants.routeUrlConfirmation) > -1) {
            navigationCommands = [ConfigConstants.routeUrlDetails, frontId, qmnum, manum];
        } else if (this.currentUrl.indexOf(ConfigConstants.routeUrlForms) > -1) {
            navigationCommands = [ConfigConstants.routeUrlDetails, frontId, qmnum, manum];
        } else if (this.currentUrl.indexOf(ConfigConstants.routeUrlDocBox) > -1) {
            navigationCommands = [ConfigConstants.routeUrlDetails, frontId, qmnum, manum];
        } else {
            // in all other cases just go to the dashboard
            navigationCommands = [ConfigConstants.routeUrlDashboard];
        }

        this.router
            .navigate(navigationCommands)
            .catch((error: Error) =>
                this.log.error(
                    'Error in NavigationLinkComponent -> router.navigate : ',
                    JSON.stringify(error, Object.getOwnPropertyNames(error)),
                ),
            );
    }
}
